import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export default function useRegulationMeasureTypes() {
	const { t: $t } = useI18n()

	const measureTypesEnum = computed(() => ({
		m2: {
			title: $t('m2'),
			value: 'm2',
		},
		m3: {
			title: $t('m3'),
			value: 'm3',
		},
		ha: {
			title: $t('ha'),
			value: 'ha',
		},
		km: {
			title: $t('km'),
			value: 'km',
		},
		m: {
			title: $t('m'),
			value: 'm',
		},
		kg: {
			title: $t('kg'),
			value: 'kg',
		},
		u: {
			title: $t('pc'),
			value: 'u',
		},
		l: {
			title: $t('l'),
			value: 'l',
		},
		h: {
			title: $t('h'),
			value: 'h',
		},
		min: {
			title: $t('min'),
			value: 'min',
		},
		sec: {
			title: $t('sec'),
			value: 'sec',
		},
		day: {
			title: $t('days'),
			value: 'day',
		},
		t: {
			title: $t('t'),
			value: 'tonn',
		},
	}))

	return {
		measureTypesEnum,
		measureTypesEnumArray: computed(() => Object.values(measureTypesEnum.value)),
	}
}
